import { StandardPopoutLabels } from '@brandfolder/react';

export const getStandardPopoutLabels = (labels: Partial<StandardPopoutLabels> = {}): StandardPopoutLabels => {
  return {
    closeButtonLabel: bfTranslate('Close'),
    loaderLabel: bfTranslate('Loading'),
    ...labels
  };
};
